import {memo} from 'react';

import DataGrid, {DataGridRow, DataGridViewProps} from '../../common/DataGrid';

const ReportDataGrid = memo(
  <T extends DataGridRow>({
    refObj,
    rows,
    columns,
    page,
    pageSize,
    loading,
    shownFields,
    defaultShownFields,
    columnWidths,
    columnOrder,
    columnFilters,
    sxFooter,
    footerStart,
    onShownFieldsChange,
    onColumnWidthsChange,
    onColumnOrderChange,
    onColumnOrderAndShownFieldsChange,
    onColumnFiltersChange,
    onPageChange,
    onPageSizeChange,
  }: DataGridViewProps<T>) => {
    return (
      <DataGrid
        ref={refObj}
        rows={rows}
        columns={columns}
        size="small"
        pagination
        page={page}
        pageSize={pageSize}
        loading={loading}
        shownFields={shownFields}
        defaultShownFields={defaultShownFields}
        columnWidths={columnWidths}
        columnOrder={columnOrder}
        columnFilters={columnFilters}
        sxFooter={sxFooter}
        footerStart={footerStart}
        onShownFieldsChange={onShownFieldsChange}
        onColumnWidthsChange={onColumnWidthsChange}
        onColumnOrderChange={onColumnOrderChange}
        onColumnOrderAndShownFieldsChange={onColumnOrderAndShownFieldsChange}
        onColumnFiltersChange={onColumnFiltersChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    );
  }
);

export default ReportDataGrid;
